var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamonds(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diamonds_svg__clip0_1225_745)",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.936 13.746a5.071 5.071 0 00-1.476-1.63c.831-.33 1.366-1.87 1.366-1.87S5.593 11.762 6.218 12a4.44 4.44 0 00-1.282 1.747v0zM2.166 5.542a5.007 5.007 0 00-1.47-1.63c.832-.329 1.367-1.875 1.367-1.875s.766 1.514 1.385 1.752a4.511 4.511 0 00-1.282 1.753v0z",
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.62 12.406S9.629 8.1 6.536 7.179c2.803-1.418 3.796-5.87 3.796-5.87s1.379 4.858 4.099 5.67c-2.823 1.56-3.583 4.563-3.81 5.427z",
    strokeWidth: 1.289
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diamonds_svg__clip0_1225_745"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.267v14.5H0z"
  })))));
}
export default SvgDiamonds;